import { render } from "./TemplatePreviewModal.vue?vue&type=template&id=0dd14fba&scoped=true&ts=true"
import script from "./TemplatePreviewModal.vue?vue&type=script&lang=ts"
export * from "./TemplatePreviewModal.vue?vue&type=script&lang=ts"

import "./TemplatePreviewModal.vue?vue&type=style&index=0&id=0dd14fba&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd14fba"]])

export default __exports__